
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const IdentificationSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Grid
      md={12}
      xs={12}
      container
      direction={"row"}
      spacing={3}
      sx={{ padding: "0px", margin: "0px" }}
    >
      <Grid
        md={4}
        xs={12}
        spacing={2}
        sx={{ padding: "0px", paddingRight: "20px" }}
      >
        <Box
          sx={{
            border: "1px solid #DBDBDB",
            borderRadius: "4px",
            p: 2,
            height: "100%",
          }}
        >
          <Grid
            sx={{
              backgroundColor: "#63B4FF33",
              color: "#2979C3",
              borderRadius: "10px",
            }}
          >
            <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
              {t("adult-patient-assessment.form-creation-info")}
            </ByzMuiTypography>
          </Grid>

          <Grid sx={{ paddingTop: "20px" }}>
            <ByzTitleAndInputBox marginLeft="0px" title={t("datetime")}>
              <Controller
                name="creationInfo.datetime"
                control={control}
                render={({ field }) => (
                  <ByzMuiDateTimePicker
                    {...field}
                    sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                  />
                )}
              />
            </ByzTitleAndInputBox>
            <ByzTitleAndInputBox
              marginLeft="0px"
              sx={{ marginTop: "10px" }}
              title={t("createdby")}
            >
              <Controller
                name="creationInfo.createdBy"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField
                    {...field}
                    sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    disabled
                    label={t("createdby")}
                  />
                )}
              />
            </ByzTitleAndInputBox>
          </Grid>
        </Box>
      </Grid>

      <Grid md={8} xs={12} spacing={2} sx={{ padding: "0px" }}>
        <Box
          sx={{
            border: "1px solid #DBDBDB",
            borderRadius: "4px",
            padding: "20px",
            height: "100%",
          }}
        >
          <Grid
            sx={{
              backgroundColor: "#63B4FF33",
              color: "#2979C3",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
              {t("adult-patient-assessment.identifying-persons")}
            </ByzMuiTypography>
            <ByzGrdDeleteButton onClick={() => console.log(`Siliniyor`)} />
          </Grid>

          <Grid container spacing={2} paddingTop={"11px"}>
            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.degree-of-relationship")}
              >
                <Controller
                  name="identifyingPerson.relationship"
                  control={control}
                  render={({ field }) => (
                    <ByzMuiSelect
                      {...field}
                      options={[]}
                      label={t("open-process-menu.select", "capitalize")}
                      placeholder={t("open-process-menu.select", "capitalize")}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.person-status")}
              >
                <Controller
                  name="identifyingPerson.personStatus"
                  control={control}
                  render={({ field }) => (
                    <ByzMuiSelect
                      {...field}
                      options={[]}
                      label={t("open-process-menu.select", "capitalize")}
                      placeholder={t("open-process-menu.select", "capitalize")}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.name")}
              >
                <Controller
                  name="identifyingPerson.name"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <ByzMuiTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.surname")}
              >
                <Controller
                  name="identifyingPerson.surname"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <ByzMuiTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.mobile-phone")}
              >
                <Controller
                  name="identifyingPerson.mobilePhone"
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField
                      {...field}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.work-phone")}
              >
                <Controller
                  name="identifyingPerson.workPhone"
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField
                      {...field}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>

            <Grid md={4} xs={6}>
              <ByzTitleAndInputBox
                marginLeft="0px"
                title={t("adult-patient-assessment.home-phone")}
              >
                <Controller
                  name="identifyingPerson.homePhone"
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField
                      {...field}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                    />
                  )}
                />
              </ByzTitleAndInputBox>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
